import { LanguageType } from '@/pages/opinion/types/common';
import { getFeedsContentText } from '@/pages/opinion/utils/languageValue';
import { keywordRenderFunc } from '@/pages/opinion/utils/text';

export const getContentInfo = (
  data: any,
  language: LanguageType,
  isShowSentiment: boolean = false,
) => {
  const text = getFeedsContentText(data, language);
  if (language === 'en' && isShowSentiment) {
    return keywordRenderFunc({
      text: text,
      sentimentInfo: data.ext1_str,
      titleCase: true,
    });
  }

  return text;
};
